import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'
import { confirmSignUp } from 'aws-amplify/auth'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import FullScreenLayout from '../components/FullScreenLayout'
import { Loader } from '../components/Loader'

export const ConfirmAccount = () => {
  const [searchParams] = useSearchParams()

  const [userName, setUserName] = useState('')
  const [confirmationCode, setConfirmationCode] = useState('')
  const [activationSuccessful, setActivationSuccessful] = useState<boolean | null>(null)

  useEffect(() => {
    if (searchParams.get('user_name')) {
      setUserName(searchParams.get('user_name') as string)
    }

    if (searchParams.get('confirmation_code')) {
      setConfirmationCode(searchParams.get('confirmation_code') as string)
    }
  }, [
    setUserName,
    setConfirmationCode,
    searchParams.get('confirmation_code'),
    searchParams.get('user_name'),
  ])

  const [error, setError] = useState('')

  useEffect(() => {
    const confirm = async () => {
      setError('')
      try {
        await confirmSignUp({ username: userName, confirmationCode })
        setActivationSuccessful(true)
      } catch (e: any) {
        setError(e.message)
        setActivationSuccessful(false)
      }
    }

    if (!!userName && !!confirmationCode) {
      confirm()
    } else {
      setError('invalid email or confirmation code')
    }
  }, [userName, confirmationCode])
  return (
    <>
      <Dialog
        open={!!error}
        onClose={() => {
          setError('')
        }}
        className="relative z-50"
      >
        <div className="fixed inset-0 bg-black/30" />
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="mx-auto w-[50rem] rounded-lg p-20 bg-primary-50">
            <DialogTitle className="text-center text-[22px] mb-4">
              Error confirming your account
            </DialogTitle>
            <Description className="py-4 text-center text-[18px] mb-4">
              There was an error confirming your account:
              <span className="font-semibold inline-block">{error}</span>
              <p>Please try again.</p>
            </Description>
          </DialogPanel>
        </div>
      </Dialog>
      <FullScreenLayout title="" subtitle="">
        <div>
          {activationSuccessful === null && (
            <Loader/>
          )}
          {activationSuccessful === true && (
          <div className="flex flex-col items-center justify-center">
            <p className="text-primary-900 font-medium text-[20px] text-center py-4">
              Your account was successfully confirmed!
            </p>
            <button
              type="submit"
              className="w-[150px] button button-large button-dark py-2 px-4"
              onClick={() => {
                window.location.href = '/sign-in'
              }}
            >
              Sign In
            </button>
          </div>
          )}
          {activationSuccessful === false && (
            <p className="text-primary-900 font-medium text-[20px] text-center">
              Your account was not confirmed, please try again.
            </p>
          )}
          
        </div>
      </FullScreenLayout>
    </>
  )
}
